<section class="content comparison-condition">
  <div class="source-card">
    <div class="row">
      <app-input-select [formData]="getSourceTypeInput('left')" />

      @if (getSourceType('left'); as sourceTypeLeft) {
        @if (sourceTypeLeft === 'fixed_value'){
          <app-input-text [formData]="getFixedValueInput('left')" />
        } @else if (['current_value', 'historical_value', 'delta_value',
          'time_range_sum', 'last_n_values_sum',
          'last_n_values_avg', 'last_n_values_min', 'last_n_values_max'
        ].includes(sourceTypeLeft)) {
          <app-input-select [formData]="getMeasurementVariableInput('left')" />
        }
      }
    </div>

    @if (['time_range_sum', 'historical_value', 'delta_value',
    ].includes(getSourceType('left') ?? '')) {
      <app-input-text [formData]="getRangeHoursInput('left')" />
    }

    @if (['last_n_values_sum', 'last_n_values_avg',
      'last_n_values_min', 'last_n_values_max',
    ].includes(getSourceType('left') ?? '')) {
      <app-input-text [formData]="getValueCountInput('left')" />
    }

  </div>

  <div class="row single">
    <app-input-select [formData]="getOperatorInput()" />
  </div>

  <div class="source-card">
    <div class="row">
      <app-input-select [formData]="getSourceTypeInput('right')" />

      @if (getSourceType('right'); as sourceTypeRight) {
        @if (sourceTypeRight === 'fixed_value'){
          <app-input-text [formData]="getFixedValueInput('right')" />
        } @else if (['current_value', 'historical_value', 'delta_value',
          'time_range_sum', 'last_n_values_sum',
          'last_n_values_avg', 'last_n_values_min', 'last_n_values_max'
        ].includes(sourceTypeRight)) {
          <app-input-select [formData]="getMeasurementVariableInput('right')" />
        }
      }
    </div>

    @if (['time_range_sum', 'historical_value', 'delta_value',
    ].includes(getSourceType('right') ?? '')) {
      <app-input-text [formData]="getRangeHoursInput('right')" />
    }

    @if (getSourceType('right'); as sourceTypeLeft) {
      @if (['last_n_values_sum', 'last_n_values_avg',
        'last_n_values_min', 'last_n_values_max',
      ].includes(sourceTypeLeft)) {
        <app-input-text [formData]="getValueCountInput('right')" />
      }
    }
  </div>
</section>

@if (this.isOverride()) {
  <section class="override">
    <div class="override-context">
      <span> {{ 'common.messages.alarm-rule.overrided' | translateSafe }} </span>
      <span> {{ 'common.messages.alarm-rule.default-value' | translateSafe }}:
        <br>
        <span [innerHtml]="getDefaultValueString"></span>
      </span>
    </div>

    <app-button-icon [iconName]="'replay'"
                     [label]="'common.actions.remove-override'"
                     [isTranslated]="true"
                     class="red"
                     (click)="removeOverride()" />
  </section>
}